import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputBase,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

export const PlaceholderCategorySelect = ({
  category,
  placeholders,
  onCopy,
}: {
  category: string;
  placeholders: { placeholderName: string }[];
  onCopy: () => void;
}) => {
  const [search, setSearch] = useState("");
  const [infoOpen, setInfoOpen] = useState(false);

  const filtered = placeholders.filter((el) =>
    el.placeholderName.toLowerCase().includes(search.toLowerCase()),
  );

  const isFinancingPlans = category.toUpperCase() === "FINANCING_PLANS";

  return (
    <>
      <FormControl sx={{ minWidth: 150 }}>
        <Select
          displayEmpty
          renderValue={() => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>{category.replace(/_/g, " ").toUpperCase()}</span>
              {isFinancingPlans && (
                <IconButton
                  size="small"
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setInfoOpen(true);
                  }}
                  sx={{ ml: 1, p: 0 }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          )}
          onChange={(e) => {
            navigator.clipboard.writeText(`{{${e.target.value}}}`);
            onCopy();
          }}
          sx={{ height: 40 }}
          MenuProps={{
            autoFocus: false,
            PaperProps: { sx: { maxHeight: 300 } },
          }}
          onClose={() => setSearch("")}
        >
          <MenuItem disableRipple onKeyDown={(e) => e.stopPropagation()}>
            <InputBase
              autoFocus
              placeholder="Cerca..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              sx={{ px: 1, width: "100%" }}
            />
          </MenuItem>
          {filtered.map((el) => (
            <MenuItem key={el.placeholderName} value={el.placeholderName}>
              {el.placeholderName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {isFinancingPlans && (
        <Dialog
          open={infoOpen}
          onClose={() => setInfoOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            Nota Bene
            <IconButton
              size="small"
              onClick={() => setInfoOpen(false)}
              sx={{ color: "error.main" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography>
              L'utilizzo dei campi legati alla formazione finanziata sarà
              gestito correttamente solo in caso di associazione univoca tra
              oggetto di catalogo e finanziata.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
